import path, {join} from 'path';

const logNamePrefix = 'debug_';
const logsExtension = '.log';

function isLogFile(fileName: string) {
    return fileName.startsWith(logNamePrefix) && fileName.endsWith(logsExtension);
}

async function deleteOldLogFilesBeside(logPath: string) {
    try {
        const logsFolder = path.dirname(logPath);
        const fs = require('fs');
        const maxLogFiles = 5;
        const entries = await fs.promises.readdir(logsFolder);
        const logFiles = entries
            .filter(isLogFile)
            .sort();

        for (let i = 0; i < logFiles.length - maxLogFiles; i++) {
            const logFile = logFiles[i];
            const oldLogPath = join(logsFolder, logFile);
            if (oldLogPath !== logPath) {
                console.log(`Removed old log '${oldLogPath}'.`);
                await fs.promises.unlink(oldLogPath);
            }
        }
    } catch (error) {
        console.error(error);
    }
}

export function generateLogName(logsFolder: string) {
    const date = new Date();
    const year = date.getUTCFullYear().toString();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const days = date.getUTCDate().toString().padStart(2, '0');

    return join(logsFolder, `${logNamePrefix}${year}${month}${days}${logsExtension}`);
}

export default function createFileTransport(logPath: string) {
    if (!isLogFile(path.basename(logPath))) {
        throw new Error(`Invalid log path '${logPath}'.`);
    }

    console.log('Log path: ', logPath);

    // noinspection JSUnusedLocalSymbols
    const _ = deleteOldLogFilesBeside(logPath);

    const {transport} = require('pino');

    return transport({
        target: 'pino/file',
        options: {
            destination: logPath,
            mkdir: true,
        },
    });
}
